export default __webpack_public_path__ + "static/media/330_dummy2016-anwaltskanzlei01-de.d040746b.png";